module.exports = __webpack_public_path__ + "img/aa.a4e2348f.png";